import { createRoot } from 'react-dom/client';
import type { Root } from 'react-dom/client';
import Dashboard from './checker/Dashboard';
import type { DashboardConfig } from './checker/types';
import './index.css';

// Expose render function globally for content script
declare global {
  interface Window {
    renderCheckerDashboard: (container: HTMLElement, config: DashboardConfig) => void;
    unmountCheckerDashboard: () => void;
  }
}

let root: Root | null = null;

window.renderCheckerDashboard = (container: HTMLElement, config: DashboardConfig) => {
  if (!root) {
    root = createRoot(container);
  }
  root.render(<Dashboard {...config} />);
};

window.unmountCheckerDashboard = () => {
  if (root) {
    root.unmount();
    root = null;
  }
};

